import { compose } from "recompose";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { deleteEquipment } from "actions/equipments/equipmentsActions";
import EquipmentsShow from "components/Equipments/EquipmentsShow";

const mapStateToProps = (state, ownProps) => {
  const { firestore, firebase } = state;

  const equipments = firestore.data.equipments;
  const equipment = equipments && equipments[ownProps.match.params.id];
  const auth = firebase.auth;
  const error = state.equipments.error;

  const isLoading = !isLoaded(equipments);
  const isDataEmpty = isEmpty(equipment);

  return {
    isLoading: isLoading,
    isEmpty: isDataEmpty,
    equipment: equipment,
    auth: auth,
    error: error
  };
};

export default compose(
  firestoreConnect([{ collection: "equipments" }]),
  connect(mapStateToProps, { deleteEquipment })
)(EquipmentsShow);
